import { FC } from 'react';

import { SkeletonBuilder } from '@telialt/common-skeleton-builder/src/SkeletonBuilder';

import { StyledSkeleton } from './MobileMenuItemComponent.styles';

export const MobileMenuItemComponentSkeleton: FC = () => {
    return (
        <StyledSkeleton>
            <SkeletonBuilder baseHeight={2} gap="0" config={[[{ height: 1, widthProportion: 1 }]]} />
        </StyledSkeleton>
    );
};
